import { useEffect, useState } from "react";

const DocumentTypeFilter = ({ docType, setDocType }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth < 640);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const options = [
    
    { value: "reference", label: "Reference Document" },
    { value: "important", label: "Important Document" },
    { value: "final", label: "Final Document" },
  ];

  /* ================= DESKTOP (native select) ================= */
  if (!isMobile) {
    return (
      <select
        value={docType}
        onChange={(e) => setDocType(e.target.value)}
        className="w-80 border px-3 py-2 rounded outline-none"
      >
        <option value=''>Select type</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    );
  }

  /* ================= MOBILE (centered modal) ================= */
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="w-full border px-3 py-2 rounded text-left bg-white"
      >
        {options.find((o) => o.value === docType)?.label || "Select Doc Type"}
      </button>

      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-xl p-5 w-11/12 max-w-sm">
            {/* <p className="font-medium mb-3 text-center">Select Document Type</p> */}
            <button 
              onClick={() => {
                  setDocType("");
                  setOpen(false);
                }}
              className="w-full text-left px-4 py-2 rounded"
            >
              clear
            </button>

            {options.map((opt) => (
              <button
                key={opt.value}
                onClick={() => {
                  setDocType((prev) => (prev === opt.value ? "" : opt.value));
                  setOpen(false);
                }}
                className={`w-full text-left px-4 py-2 rounded ${
                docType === opt.value
                  ? "bg-blue-100 text-blue-700 font-medium"
                  : "hover:bg-zinc-100"
                }`}
              >
                {opt.label}
              </button>

            ))}

            <button
              onClick={() => setOpen(false)}
              className="w-full mt-4 py-2 text-center text-red-600 font-medium"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default DocumentTypeFilter;
